module.exports = __webpack_public_path__ + "static/media/icn-overflow-menu.9420ecc9.svg";